module.exports = __webpack_public_path__ + "img/HZ-P1010.7ba252a2.jpg";